/*
 * @Author: liyunfei12354 3090384495@qq.com
 * @Date: 2024-07-08 14:03:28
 * @LastEditors: liyunfei12354 3090384495@qq.com
 * @LastEditTime: 2025-09-23 16:37:10
 * @FilePath: \vr-exp-h5-frontend\src\assets\js\webgl.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 *
 * 判断是否支持webgl,
 * 如果不支持，判断微信版本，
 * 微信版本低于6.5.2，提醒微信版本低，
 * 否则提醒系统版本低
 */

let isSupportWebgl = {}
isSupportWebgl.tipMsg = '抱歉，您的手机系统不支持查看模型功能！'
isSupportWebgl.title = '系统版本低'

function isWebgl() {
    const canvas = document.createElement('canvas')
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
    if (gl && gl instanceof WebGLRenderingContext) {
        isSupportWebgl.webgl = true
    } else {
        isSupportWebgl.webgl = false
        // const wechatInfo = navigator.userAgent.match(/MicroMessenger\\([\\d\\.]+)/i)
        // if (wechatInfo[1] < '6.5.2') {
        //     isSupportWebgl.tipMsg = '抱歉，您的微信版本低，不支持查看模型功能，请升级您的微信版本！'
        //     isSupportWebgl.title = '微信版本低'
        // } else {
        //     isSupportWebgl.tipMsg = '抱歉，您的手机系统不支持查看模型功能！'
        //     isSupportWebgl.title = '系统版本低'
        // }
    }
}
isWebgl()

export default isSupportWebgl
